import * as React from 'react';

export type CheckBoxPosition = 'left' | 'right';
export type CheckBoxVerticalPosition = "top" | "center";

export interface ICheckBoxProps {
    onChangehandler: () => void;
    isChecked: boolean;
    isDisabled?: boolean;
    position?: CheckBoxPosition;
    verticalPosition?: CheckBoxVerticalPosition;
    customClass?: string;
    roleForTest?: string;
    isUpdating?: boolean;
}


export const CheckBox: React.FC<ICheckBoxProps> = (props) => {
    return (
        <div className={`d-flex align-items-${props.verticalPosition === 'top' ? 'top' : 'center'} fake-checkbox-wrapper ${props.isDisabled ? 'disabled' : ''} ${props.customClass ? props.customClass : ''}`}
            onClick={() => { if (!props.isDisabled) { props.onChangehandler(); } }}
            data-test-role={props.roleForTest}
        >
            {
                props.position !== 'right' &&
                (props.isUpdating
                    ?
                    <span className="fas fa-spinner fa-spin"></span>
                    :
                    <span className={`fa fake-checkbox ${props.isChecked ? 'fa-check checked' : ''} mr-2`}></span>
                )
            }
            <span className="checkbox-label">{props.children}</span>
            {
                props.position === 'right' &&
                (props.isUpdating
                    ?
                    <span className="fas fa-spinner fa-spin"></span>
                    :
                    <span className={`fa fake-checkbox ${props.isChecked ? 'fa-check checked' : ''} ml-2`}></span>
                )
            }
        </div>
    )
}